export default __webpack_public_path__ + "static/media/9.0246369d.png";